<template>
  <v-container>
    <GoBackBtn :routeToGo="routeToGo" :tabId="false" />
    <PageHeader class="pb-1" title="Tenant" />
    <v-row justify="center">
      <v-col cols="12" md="8" lg="6">
        <v-card class="pa-0">
          <v-card-title style="font-size: 14px">Credenciales</v-card-title>
          <v-card-text>
            <v-form
              v-model="isFormValid"
              ref="tenant-form"
              form="tenant-form"
              id="tenant-form"
              @submit.prevent="saveConfig()"
            >
              <v-text-field
                v-model="tenant.idAplicacionCliente"
                outlined
                dense
                label="Id. de aplicación (cliente)"
                :append-icon="
                  showIdAplicacionCliente ? 'mdi-eye' : 'mdi-eye-off'
                "
                :type="showIdAplicacionCliente ? 'text' : 'password'"
                autocomplete="new-password"
                @click:append="
                  showIdAplicacionCliente = !showIdAplicacionCliente
                "
              ></v-text-field>
              <v-text-field
                v-model="tenant.idDirectorioInquilino"
                outlined
                dense
                label="Id. de directorio (inquilino)"
                :append-icon="
                  showIdDirectorioInquilino ? 'mdi-eye' : 'mdi-eye-off'
                "
                :type="showIdDirectorioInquilino ? 'text' : 'password'"
                autocomplete="new-password"
                @click:append="
                  showIdDirectorioInquilino = !showIdDirectorioInquilino
                "
              ></v-text-field>
              <v-text-field
                v-model="tenant.secreto"
                outlined
                dense
                label="Secreto"
                :append-icon="showSecreto ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showSecreto ? 'text' : 'password'"
                autocomplete="new-password"
                @click:append="showSecreto = !showSecreto"
              ></v-text-field>
              <v-text-field
                v-model="tenant.openAIApiKey"
                outlined
                dense
                label="API key de OpenAI"
                :append-icon="showOpenAIApiKey ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showOpenAIApiKey ? 'text' : 'password'"
                autocomplete="new-password"
                @click:append="showOpenAIApiKey = !showOpenAIApiKey"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn
              small
              color="primary"
              form="tenant-form"
              type="submit"
              :loading="loading"
              :disabled="loading || !isFormValid"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageHeader from "@/components/ui/PageHeader.vue";
import GoBackBtn from "@/components/shared/GoBackBtn";
import { mapActions } from "vuex";

export default {
  name: "Tenant",
  components: { PageHeader, GoBackBtn },
  data() {
    return {
      routeToGo: "/",
      isFormValid: false,
      loading: false,
      showIdAplicacionCliente: false,
      showIdDirectorioInquilino: false,
      showSecreto: false,
      showOpenAIApiKey: false,
      tenant: {
        idAplicacionCliente: "",
        idDirectorioInquilino: "",
        secreto: "",
        openAIApiKey: "",
      },
    };
  },
  async mounted() {
    await this.setTenantConfig();
  },
  methods: {
    ...mapActions({
      getTenantConfig: "user/getTenantConfig",
      saveTenantConfig: "user/saveTenantConfig",
      setAlert: "user/setAlert",
    }),
    async setTenantConfig() {
      this.loading = true;
      try {
        const response = await this.getTenantConfig();
        this.tenant = {
          idAplicacionCliente: response?.idAplicacionCliente ?? "",
          idDirectorioInquilino: response?.idDirectorioInquilino ?? "",
          secreto: response?.secreto ?? "",
          openAIApiKey: response?.openAIApiKey ?? "",
        };
      } finally {
        this.loading = false;
      }
    },
    async saveConfig() {
      this.loading = true;
      try {
        const response = await this.saveTenantConfig(this.tenant);
        if (response.status === 200 && response.data.data) {
          this.setAlert({ type: "success", message: "Guardado con exito." });
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
